var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "basePopup", role: "dialog" } },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg custom-modal-class" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "pop_wrapper" }, [
                  _c(
                    "div",
                    { attrs: { id: "left" } },
                    [
                      _c("profile-menu", {
                        attrs: {
                          roleId: _vm.roleId,
                          activeTab: _vm.activeTab,
                          isDashboardCustomizable: _vm.isDashboardCustomizable,
                        },
                        on: { menuClicked: _vm.menuClicked },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { attrs: { id: "right" } },
                    [
                      _vm.profileMenuClicked !== "logout"
                        ? _c("common-header", {
                            attrs: {
                              roleId: _vm.roleId,
                              displaySubheader: _vm.displaySubheader,
                              header: _vm.header,
                              subheader: _vm.subheader,
                              breadcrumb: _vm.breadcrumb,
                              isDashboardCustomizable:
                                _vm.isDashboardCustomizable,
                            },
                            on: {
                              closepopup: _vm.closepopup,
                              "emit-close-event": _vm.closePage,
                              changePage: _vm.getPageName,
                            },
                          })
                        : _vm._e(),
                      _vm.profileMenuClicked == "profile"
                        ? [
                            _c("profile-popup", {
                              ref: "profilePopUp",
                              attrs: { closeSubPage: _vm.closeSubPage },
                              on: {
                                closedConfirmPopup: _vm.redirectProfile,
                                closepopup: _vm.closepopup,
                                emitBreadCrumb: _vm.updateBreadCrumb,
                                logoutUser: _vm.logoutUser,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm.profileMenuClicked == "team"
                        ? [
                            _c("team", {
                              attrs: {
                                roleId: _vm.roleId,
                                closeSubPage: _vm.closeSubPage,
                              },
                              on: {
                                closepopup: _vm.closepopup,
                                emitBreadCrumb: _vm.updateBreadCrumb,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm.profileMenuClicked == "preferences"
                        ? [
                            _c("preferences", {
                              attrs: { roleId: _vm.roleId },
                              on: { closepopup: _vm.closepopup },
                            }),
                          ]
                        : _vm._e(),
                      _vm.profileMenuClicked == "notifications"
                        ? [
                            _c("notifications", {
                              attrs: {
                                roleId: _vm.roleId,
                                regWatchprefTab: _vm.regWatchprefTab,
                                account_id: _vm.account_id,
                              },
                              on: { closepopup: _vm.closepopup },
                            }),
                          ]
                        : _vm._e(),
                      _vm.profileMenuClicked == "billing"
                        ? [
                            _c("billing", {
                              attrs: {
                                closeSubPage: _vm.closeSubPage,
                                roleId: _vm.roleId,
                              },
                              on: {
                                closepopup: _vm.closepopup,
                                emitBreadCrumb: _vm.updateBreadCrumb,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm.profileMenuClicked == "services"
                        ? [
                            _c("services", {
                              attrs: { roleId: _vm.roleId },
                              on: { closepopup: _vm.closepopup },
                            }),
                          ]
                        : _vm._e(),
                      _vm.profileMenuClicked == "dashboard"
                        ? [
                            _c("dashboard", {
                              attrs: { roleId: _vm.roleId },
                              on: { closepopup: _vm.closepopup },
                            }),
                          ]
                        : _vm._e(),
                      _vm.profileMenuClicked == "tour"
                        ? [
                            _c("virtual-tour", {
                              attrs: { roleId: _vm.roleId },
                              on: { closepopup: _vm.closepopup },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }